export enum AgeGroupEnum {
  PUPPY = 1,
  ADULT = 2,
  SENIOR = 3
}
